import uiLoadSuccess from './load-success/index.vue'

export { uiLoadSuccess }
